import React from "react";
import { Box, CustomMultiSelect, ItemType, MultiSelectCustomTarget, TitleComponent } from "ui-components";
import { CATEGORY_OPTIONS_OBJ } from "../../../../utils/constants";


type Props = {
	values: string[];
	setValues: (values: string[]) => void;
	changeFormData:(name:string,value:any)=>void;
	classname?:string;
};

const Categories = ({ values, setValues,changeFormData,classname}:Props) => {
	const customTarget = values.length;
	const renderCustomTarget = (selectedItems: ItemType[]) => (
		<MultiSelectCustomTarget
			count={selectedItems.length}
			text={`Status selected`}
		/>
	);
	return (
		<Box flexDir="row" items="center" justify="between" >
			<TitleComponent fontSize="15px" marginRight="30px" marginTop="0px">Category:</TitleComponent>
			<CustomMultiSelect
				items={CATEGORY_OPTIONS_OBJ ?? []}
				values={values ?? []}
				onSelect={(item: ItemType) => {
					let newValues;
					if (!values.includes(item.value)) {
						setValues([...values, item.value]);
						newValues = [...values,item.value];
					}
					else{
						const valueStr = String(item.value).toUpperCase();
						const filteredValues = values.filter(v => v !== valueStr);
						setValues(filteredValues);
						newValues = filteredValues;
					}
					changeFormData("companyDetail.industry.category", newValues);
				}}
				onRemove={(_value) => {
					const valueStr = CATEGORY_OPTIONS_OBJ.filter(ele=>ele.label=== _value)[0].value;
					const newValues = values.filter(v => v !== valueStr);
					setValues(newValues);
					changeFormData("companyDetail.industry.category", newValues);
				}}
				customTarget={customTarget ? renderCustomTarget : undefined}
				className={`${classname ? classname : "w-100"}`}
			/>
		</Box>
	);
};

export default Categories;